// 一日一分の習慣：今日のテーマに合わせた、短い瞑想・気功の提案
// 医療・健康効果をうたわない。「〜してみましょう」程度のお誘いに留める。
import type { ThemeKey } from './themes';

const PRACTICES: Record<ThemeKey, string[]> = {
  moon: [
    '月のある方角に顔を向けて、ゆっくり三回深呼吸。吐く息で、今日の出来事をそっと手放してみましょう。',
    '両手を胸の前で合わせ、月の光が手のひらに集まる様子を思い描きながら、一分間静かに呼吸しましょう。',
    '目を閉じて、満ち欠けする月のように、吸う息で満ち、吐く息で静まる感覚を味わってみましょう。',
  ],
  sun: [
    '窓を開けて、深呼吸を三回。空の向こうに意識を向けてみましょう。',
    '光の差す方へ両手を広げ、吸いながら背伸び、吐きながら力を抜く。これをゆっくり数回くり返しましょう。',
    '目を閉じて、胸のあたりに小さな太陽が灯っている様子を思い描き、一分間その温かさに意識を向けましょう。',
  ],
  spaceWeather: [
    '目を閉じて、頭のてっぺんから空へ一本の光の柱が伸びている様子を思い描き、一分間静かに呼吸しましょう。',
    '両手のひらを少し離して向かい合わせ、その間に温かな気の玉があるつもりで、ゆっくり呼吸しましょう。',
    '背すじをすっと伸ばして座り、呼吸に合わせて、地球を包む大きな空気の層を感じてみましょう。',
  ],
  nightSky: [
    '寝る前に一分だけ灯りを落とし、満天の星を思い浮かべながら、呼吸を十まで数えてみましょう。',
    '外に出られたら、空でいちばん明るい星を見つけて、その光に一分間意識を向けてみましょう。',
    '目を閉じて、遠い星から届く光が自分の上に降りそそぐ様子を思い描き、静かに呼吸しましょう。',
  ],
  earth: [
    '足の裏を床にしっかりつけ、大地とつながる感覚で、ゆっくり十回呼吸しましょう。',
    '立ったまま膝を軽くゆるめ、体を左右にゆらゆら揺らしながら一分。肩の力が抜けていくのを感じましょう。',
    '手のひらをおへその下に重ね、吸う息でおなかがふくらみ、吐く息でしぼむのを一分間感じてみましょう。',
  ],
};

/** その日のテーマに合わせた一分の提案（同じ日なら同じ文面） */
export function dailyPractice(theme: ThemeKey, now: Date): string {
  const list = PRACTICES[theme];
  const dayNo = Math.floor(new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime() / 86400000);
  return list[((dayNo % list.length) + list.length) % list.length];
}
